import React, { useEffect, useState } from 'react';
import { Users, UserCheck, Wallet, TrendingUp, Receipt, Clock } from 'lucide-react';
import api from '@/lib/api';
import { formatTL, formatNum } from '@/lib/format';
import { useTokens } from '@/lib/theme';
import { Card } from '@/components/shared';

export default function AdminOverview() {
  const [data, setData] = useState(null);
  const t = useTokens();

  useEffect(() => {
    api.get('/admin/overview').then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return <div className="text-navy/40 text-sm">Yükleniyor...</div>;

  const stats = [
    { icon: Users, label: 'Toplam mimar', value: formatNum(data.totalArchitects), color: t.ink },
    { icon: UserCheck, label: 'Aktif mimar', value: formatNum(data.activeArchitects), color: t.pos },
    { icon: Clock, label: 'Onay bekleyen', value: formatNum(data.pendingApprovals), color: t.gold },
    { icon: TrendingUp, label: 'Bu ay ciro', value: formatTL(data.monthSalesVolume), color: t.ink },
    { icon: Wallet, label: 'Bu ay komisyon', value: formatTL(data.monthCommission), color: t.pos },
    { icon: Receipt, label: 'Bu ay satış', value: formatNum(data.monthSalesCount), color: t.ink },
  ];

  return (
    <div className="fade-up" data-testid="admin-overview">
      <h1 className="font-serif text-3xl text-navy mb-1">Genel Bakış</h1>
      <p className="text-navy/50 text-sm mb-8">Mimar Partner programı özeti</p>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-4">
        {stats.map((s, i) => (
          <Card key={i} className="p-5">
            <s.icon strokeWidth={1.25} className="w-5 h-5 mb-3" style={{ color: s.color }} />
            <div className="font-serif text-2xl md:text-3xl text-navy">{s.value}</div>
            <div className="text-navy/50 text-sm mt-1">{s.label}</div>
          </Card>
        ))}
      </div>

      {(data.readyToPay > 0 || data.pendingCommission > 0) && (
        <Card className="p-5 mt-6 flex items-center gap-3">
          <Wallet strokeWidth={1.25} className="w-5 h-5 text-gold" />
          <p className="text-sm text-navy">
            <span className="font-medium">{formatTL(data.readyToPay || 0)}</span> ödemeye hazır ·{' '}
            <span className="font-medium">{formatTL(data.pendingCommission || 0)}</span> onay bekliyor.
          </p>
        </Card>
      )}
    </div>
  );
}
